import { generateApiActions } from './action-helpers';

const types = {
  FETCH_REQUEST_LOGS: 'FETCH_REQUEST_LOGS',
  REMOVE_REQUEST_LOG: 'REMOVE_REQUEST_LOG',
};

export const {
  fetchRequestLogsRequest,
  fetchRequestLogsSuccess,
  fetchRequestLogsFailure,
} = generateApiActions(types.FETCH_REQUEST_LOGS);

export const {
  removeRequestLogRequest,
  removeRequestLogSuccess,
  removeRequestLogFailure,
} = generateApiActions(types.REMOVE_REQUEST_LOG);



// WEBPACK FOOTER //
// ./src/redux/actions/request-logs.js